import L from 'leaflet'

// Leaflet 1.9.x schedules a 250ms fallback for every animated zoom
// (_animateZoom -> setTimeout(_onZoomTransitionEnd, 250)), and Map.remove()
// does not cancel it. If the map is torn down while a zoom is in flight (e.g.
// closing the plan view), that timer runs _onZoomTransitionEnd on a map with no
// _mapPane and throws. Leaflet guards the pane inside that method but not the
// _move() call after it, so bail out once the map has been removed.
// Private API: re-check this when upgrading leaflet.
const originalOnZoomTransitionEnd = L.Map.prototype._onZoomTransitionEnd

L.Map.prototype._onZoomTransitionEnd = function () {
  if (!this._mapPane) return

  return originalOnZoomTransitionEnd.call(this)
}
